import { merge, $ } from "glamor";
import React, { PropsWithChildren } from "react";
import { theme } from "styles/theme";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";

interface IProps {
    title: string | React.ReactElement;
    message: string | React.ReactElement;
}

export const ViewportDetectComponent: React.FunctionComponent<PropsWithChildren<IProps>> = ({
    title,
    message,
    children,
}) => {
    const styles = React.useMemo(
        () =>
            merge(
                {
                    display: "flex",
                    flexFlow: "column",
                    backgroundColor: theme.palette.lightGrey,
                    padding: "10px",
                },
                $(" > div", {
                    padding: "10px 0",
                    alignSelf: "center",
                    textAlign: "center",
                    color: "black",
                }),
                $(" .icon svg", {
                    width: "96px",
                    height: "96px",
                    color: theme.palette.warning,
                })
            ),
        []
    );
    const [tooSmall, setTooSmall] = React.useState<boolean>(false);
    const handleViewportResize = React.useCallback(
        ({ matches }) => tooSmall !== !!matches && setTooSmall(matches),
        [tooSmall, setTooSmall]
    );

    React.useEffect(() => {
        const mediaQueryList = window.matchMedia("(max-width: 768px)");
        const hasAddEventListener = !!mediaQueryList.addEventListener;
        handleViewportResize(mediaQueryList);
        hasAddEventListener
            ? mediaQueryList.addEventListener("change", handleViewportResize)
            : mediaQueryList.addListener(handleViewportResize);
        return () =>
            hasAddEventListener
                ? mediaQueryList.removeEventListener("change", handleViewportResize)
                : mediaQueryList.removeListener(handleViewportResize);
    }, [handleViewportResize]);

    return (
        <>
            {tooSmall && (
                <div {...styles}>
                    <div className="icon">
                        <ErrorOutlineOutlinedIcon fontSize="large" />
                    </div>
                    <div>{title}</div>
                    <div>{message}</div>
                </div>
            )}
            {!tooSmall && children}
        </>
    );
};
